export default __webpack_public_path__ + "static/media/June2011.c1b16551.png";